import React from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import styled from 'styled-components'
import arraySort from 'array-sort'

import Organizations from '../mini/Organizations'
import UserAvatar from '../mini/UserAvatar'
import ButtonC from '../typography/buttons/ButtonC'
import H2 from '../typography/headers/H2'
import Caption1 from '../typography/captions/Caption1'
import Caption4 from '../typography/captions/Caption4'
import GearIcon from '../../static/images/icon_gearmenu_off.svg'
import UserName from '../mini/UserName'
import FlexAlignCenter from '../presentational/FlexAlignCenter'

import { logoutAndRedirect } from '../../actions/user'
import { getDisplayRole } from '../../utils/user'

const OverFlowMenu = styled.div`
  visibility: ${props => (props.active ? 'visible' : 'hidden')};
  position: absolute;
  width: 360px;
  bottom: 15px;
  left: 67px;
  background: white;
  color: black;
  z-index: 2;
  border-radius: 10px;
  opacity: ${props => (props.active ? '1' : '0')};
  transition: visibility 0.15s, opacity 0.15s linear;
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.15);
`

const CurrentOrgContainer = styled.div`
  position: relative;
  min-height: 101px;
  display: flex;
  align-items: center;
  padding: 0 17px;

  .user-photo-wrapper {
    cursor: default;
  }
`

const SignOutContainer = styled.div`
  height: 70px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

const Gear = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
  width: 19px;
  height: 19px;
  margin-left: 6px;
  cursor: pointer;
  background: url(${GearIcon});
`
class UserOrgMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuActive: false
    }
    this.logoutBound = this.logout.bind(this)
    this.onOverflowMouseOutBound = this.onOverflowMouseOut.bind(this)
    this.onOverflowMouseOverBound = this.onOverflowMouseOver.bind(this)
    this.onAccountClickBound = this.onAccountClick.bind(this)
  }

  render() {
    const { user, organization, dispatch } = this.props
    const userOrgs = this.getUserOrganizations(user, organization.id)

    return (
      <React.Fragment>
        <div
          onFocus={this.onOverflowMouseOverBound}
          onBlur={this.onOverflowMouseOutBound}
          onMouseOver={this.onOverflowMouseOverBound}
          onMouseOut={this.onOverflowMouseOutBound}
          style={{ padding: '17px 0' }}
        >
          <UserAvatar
            wrapperClass="user-org-menu-nav"
            photoUrl={user.photo.url}
            name={user.name}
          />
        </div>
        <OverFlowMenu
          active={this.state.menuActive}
          onMouseOver={this.onOverflowMouseOverBound}
          onMouseOut={this.onOverflowMouseOutBound}
          onFocus={this.onOverflowMouseOverBound}
          onBlur={this.onOverflowMouseOutBound}
        >
          <CurrentOrgContainer>
            <UserAvatar photoUrl={user.photo.url} name={user.name} />
            <div style={{ paddingLeft: '12px' }}>
              <FlexAlignCenter>
                <UserName
                  activeCertifications={user.active_certifications}
                  userId={`user-org-menu-${user.id}`}
                  rebuild
                >
                  <H2>{user.name}</H2>
                </UserName>
              </FlexAlignCenter>
              <Caption4>{organization.name}</Caption4>
              <Caption1>{getDisplayRole(organization.roles)}</Caption1>
            </div>
            <Gear onClick={this.onAccountClickBound} />
          </CurrentOrgContainer>
          {user.organizations.length > 1 && (
            <div className="organizations-wrapper">
              <Organizations
                dispatch={dispatch}
                organizations={arraySort(userOrgs, ['name'])}
                user={user}
              />
            </div>
          )}
          <SignOutContainer>
            <ButtonC onClick={this.logoutBound}>Sign Out</ButtonC>
          </SignOutContainer>
        </OverFlowMenu>
      </React.Fragment>
    )
  }

  onAccountClick(e) {
    e.stopPropagation() // prevent this from bubbling up to route to profile
    this.props.dispatch(push('/account'))
  }

  getUserOrganizations(user, currentOrgId) {
    return user.organizations.filter(org => org.id !== currentOrgId)
  }

  logout() {
    this.props.dispatch(logoutAndRedirect())
  }

  onOverflowMouseOver() {
    this.setState(() => ({
      menuActive: true
    }))
  }

  onOverflowMouseOut() {
    this.setState(() => ({
      menuActive: false
    }))
  }
}

UserOrgMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired
}

export default UserOrgMenu



// WEBPACK FOOTER //
// ./src/components/navigation/UserOrgMenu.js